<template>
    <v-card class="soli-round">
        <v-container class="px-3" fluid>
            <ReportHeader
                filter
                :subtitle="`${$page.props.auth.user.selected_location.name} Lesson History`"
                :selectedLocation="$page.props.auth.user.selected_location"
                :dateRange="dateRange"
                :reportUrl="`/profile/${this.user.id}/attendance`"
                :params="{ viewNotes: Number(viewNotes) }"
                dateOptions="past, upcoming, month, year"
                @loading="loading = $event"
                @search="search = $event"
            >
                <template #filterItem>
                    <div class="flex flex-col pb-1">
                        <v-list-item class="flex justify-center">
                            <v-btn
                                :ripple="false"
                                outlined
                                class="flex soli-round soli-grey"
                                @click="
                                    $inertia.reload({
                                        data: { viewNotes: Number(!viewNotes) },
                                    })
                                "
                            >
                                <small class="mr-2">
                                    {{ "View Attendance Notes" }}
                                </small>
                                <v-icon :color="viewNotes ? 'accent' : null">{{
                                    viewNotes ? "toggle_on" : "toggle_off"
                                }}</v-icon></v-btn
                            >
                        </v-list-item>
                        <v-list-item class="flex justify-center">
                            <v-btn
                                :ripple="false"
                                outlined
                                class="flex soli-round soli-grey"
                                @click="
                                    $inertia.reload({
                                        data: {
                                            viewCreditEligible: Number(
                                                !viewCreditEligible
                                            ),
                                        },
                                    })
                                "
                            >
                                <small class="mr-2">View Credit-Eligible</small>
                                <v-icon
                                    :color="
                                        viewCreditEligible ? 'accent' : null
                                    "
                                    >{{
                                        viewCreditEligible
                                            ? "toggle_on"
                                            : "toggle_off"
                                    }}</v-icon
                                >
                            </v-btn>
                        </v-list-item>
                    </div>
                </template>
            </ReportHeader>
            <v-skeleton-loader
                type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line,list-item-avatar-three-line"
                class="mb-6 pl-1 pt-2"
                style="max-width: 600px"
                boilerplate
                v-if="!attendances"
            ></v-skeleton-loader>
            <v-data-table
                v-if="attendances"
                :headers="headers"
                :items="attendances"
                hide-default-footer
                disable-pagination
                no-data-text="No lessons found"
                @click:row="$log($event.id)"
                :search="search"
                :loading="loading"
                :disable-sort="$vuetify.breakpoint.xs"
            >
                <template v-slot:[`item.lesson.starts_at`]="{ item }">
                    <AttendanceDate :date="item.lesson.starts_at" />
                </template>

                <template v-slot:[`item.lesson.details`]="{ item }">
                    <div class="py-4">
                        <AttendanceInfo :attendance="item" />
                        <AttendanceTitle :attendance="item" />
                        <AttendanceLesson :lesson="item.lesson" />
                    </div>
                </template>

                <template v-slot:[`item.purchaseOption.name`]="{ item }">
                    <AttendanceOption
                        :attendance="item"
                        :purchaseOption="item.purchaseOption"
                        @success="$emit('success')"
                        @reset="$emit('reset')"
                    />
                </template>

                <template v-slot:[`item.status`]="{ item }">
                    <AttendanceStatus
                        :attendance="item"
                        :student="user"
                        @success="$emit('success')"
                        @reset="$emit('reset')"
                    />
                </template>

                <template v-slot:[`item.lesson_note`]="{ item }">
                    <TipTapReader :value="item.lesson_note" class="mt-4" />
                </template>
                <template v-slot:[`item.practice_note`]="{ item }">
                    <TipTapReader :value="item.practice_note" class="mt-4" />
                </template>
            </v-data-table>
        </v-container>
    </v-card>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";
import AttendanceDate from "./Attendance/AttendanceDate.vue";
import AttendanceLesson from "./Attendance/AttendanceLesson.vue";
import AttendanceTitle from "./Attendance/AttendanceTitle.vue";
import AttendanceOption from "./Attendance/AttendanceOption.vue";
import AttendanceInfo from "./Attendance/AttendanceInfo.vue";
import AttendanceStatus from "./Attendance/AttendanceStatus.vue";
import ReportHeader from "./../Reports/ReportHeader.vue";
import TipTapReader from "../Editor/TipTapReader.vue";

export default {
    mixins: [globalMoment],
    props: {
        attendances: {
            type: Array,
            default: null,
        },
        user: {},
        dateRange: {
            type: Array,
            default: () => [],
        },
        viewNotes: {
            type: Boolean,
            default: false,
        },
        viewCreditEligible: {
            type: Boolean,
            default: false,
        },
        errors: {},
    },
    components: {
        AttendanceDate,
        AttendanceLesson,
        AttendanceTitle,
        AttendanceOption,
        AttendanceStatus,
        AttendanceInfo,
        ReportHeader,
        TipTapReader,
    },
    data: function () {
        return {
            loading: false,
            search: "",
        };
    },
    computed: {
        headers() {
            return [
                {
                    text: "When",
                    value: "lesson.starts_at",
                    sortable: true,
                    align: "center",
                    hidden: false,
                },
                {
                    text: "Lesson",
                    value: "lesson.details",
                    sortable: false,
                    align: "start",
                    hidden: false,
                },
                {
                    text: "Purchase Option",
                    value: "purchaseOption.name",
                    sortable: true,
                    align: "start",
                    hidden: this.viewNotes,
                },
                {
                    text: "Status",
                    value: "status",
                    sortable: true,
                    align: "start",
                    hidden: false,
                    hidden: this.viewNotes,
                },
                {
                    text: "Lesson Notes",
                    value: "lesson_note",
                    sortable: false,
                    align: "start",
                    hidden: !this.viewNotes,
                    width: "30%",
                },
                {
                    text: "Practice Notes",
                    value: "practice_note",
                    sortable: false,
                    align: "start",
                    hidden: !this.viewNotes,
                    width: "30%",
                },
            ].filter((e) => !e.hidden);
        },
    },
};
</script>
